/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_Code_MessageInputs */

const en_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a 7-character letter-number combination.`)
};

const ar_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدم مزيجًا من 7 أحرف وأرقام.`)
};

const de_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwende eine 7-stellige Buchstaben-Zahlen-Kombination.`)
};

const es_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa una combinación de 7 letras y números.`)
};

const fr_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez une combinaison de 7 lettres et chiffres.`)
};

const it_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa una combinazione di 7 lettere e numeri.`)
};

const ja_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7文字の英数字の組み合わせを入力してください。`)
};

const ko_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문자와 숫자를 조합한 7자 코드를 입력해 주세요.`)
};

const pt_br_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use uma combinação de 7 letras e números.`)
};

const ru_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте комбинацию из 7 букв и цифр.`)
};

const th_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้รหัส 7 ตัวที่ผสมตัวอักษรและตัวเลข`)
};

const tr_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 karakterlik harf-rakam kombinasyonu kullan.`)
};

const zh_cn_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码为 7 码数字与字母组合。`)
};

const zh_tw_invalid_code_message = /** @type {(inputs: Invalid_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請碼為 7 碼數字與字母組合。`)
};

/**
* | output |
* | --- |
* | "Use a 7-character letter-number combination." |
*
* @param {Invalid_Code_MessageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invalid_code_message = /** @type {((inputs?: Invalid_Code_MessageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_Code_MessageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalid_code_message(inputs)
	if (locale === "ar") return ar_invalid_code_message(inputs)
	if (locale === "de") return de_invalid_code_message(inputs)
	if (locale === "es") return es_invalid_code_message(inputs)
	if (locale === "fr") return fr_invalid_code_message(inputs)
	if (locale === "it") return it_invalid_code_message(inputs)
	if (locale === "ja") return ja_invalid_code_message(inputs)
	if (locale === "ko") return ko_invalid_code_message(inputs)
	if (locale === "pt_br") return pt_br_invalid_code_message(inputs)
	if (locale === "ru") return ru_invalid_code_message(inputs)
	if (locale === "th") return th_invalid_code_message(inputs)
	if (locale === "tr") return tr_invalid_code_message(inputs)
	if (locale === "zh_cn") return zh_cn_invalid_code_message(inputs)
	return zh_tw_invalid_code_message(inputs)
});